import React from 'react'
import chachou from '../assets/images/PassChachou.PNG'
import pascalou from '../assets/images/passPascalou.PNG'
import ludo from '../assets/images/passLudo.PNG'
import '../assets/styles/pass.css'
import { Link } from 'react-router-dom'

function Pass() {
  return (
    <div className="pass">
    <h1>Les pass</h1>
    <table className='table'>
      <div className="passZone">
        <h2>Pass Chachou</h2>
        <img src={chachou} alt="pass Chachou" />
        <a target= "blank" href="https://festival-gerardmer.com/2023/"><button>ESPACE MEMBRE</button></a>
      </div>
    </table>
    <table className='table'>
    <div  className="passZone">
      <h2>Pass Ludo</h2>
      <img src={ludo} alt="pass Ludo" />
      <a target= "blank" href="https://festival-gerardmer.com/2023"><button>ESPACE MEMBRE</button></a>
    </div>
    </table>
    <table className='table'>
    <div className="passZone">
      <h2>Pass Pascalou</h2>
      <img src={pascalou} alt="pass Pascalou" />
      <a target= "blank" href="https://festival-gerardmer.com/2023"><button>ESPACE MEMBRE</button></a>
    </div>
    </table>
    <div>
    <Link to='/accueil'><button style={{margin: "20px 0px", padding: "10px", width: "200px", backgroundColor:"red", border: "none", borderRadius: "10px"}}>RETOUR ACCUEIL</button></Link>
    </div>
    </div>
  )
}

export default Pass